// Maps OLC contacts to the normalized shape the SDK template preview expects:
// a title/subtitle for the picker plus a merge-token -> value map. The token
// mapping mirrors the server's CONTACT_DEFAULT_FIELDS (batch-order-pdf.service).

const CONTACT_TOKEN_TO_PROPERTY = {
  '{{C.FIRST_NAME}}': 'firstName',
  '{{C.LAST_NAME}}': 'lastName',
  '{{C.COMPANY_NAME}}': 'companyName',
  '{{C.ADDRESS_1}}': 'address1',
  '{{C.ADDRESS_2}}': 'address2',
  '{{C.CITY}}': 'city',
  '{{C.STATE}}': 'state',
  '{{C.ZIP_CODE}}': 'zip',
  '{{C.PHONE_NUMBER}}': 'phoneNo',
  '{{C.EMAIL}}': 'email',
};

const PROPERTY_TOKEN_TO_PROPERTY = {
  '{{C.PROPERTY_ADDRESS}}': 'address1',
  '{{C.PROPERTY_CITY}}': 'city',
  '{{C.PROPERTY_STATE}}': 'state',
  '{{C.PROPERTY_ZIP_CODE}}': 'zip',
};

const getContactTitle = (contact) => {
  const fullName =
    contact?.fullName && contact.fullName !== 'null'
      ? contact.fullName
      : [contact?.firstName, contact?.lastName].filter(Boolean).join(' ');

  return fullName || contact?.companyName || contact?.email || `Contact ${contact?.id}`;
};

const getContactSubtitle = (contact) => {
  const street = [contact?.address1, contact?.address2].filter(Boolean).join(' ');
  const region = [contact?.state, contact?.zip].filter(Boolean).join(' ');
  return [street, contact?.city, region].filter(Boolean).join(', ');
};

// meta.custom_fields is an array of single-key objects keyed by the field label.
const getCustomFieldValues = (contact) =>
  (contact?.meta?.custom_fields || []).reduce((values, entry) => ({ ...values, ...entry }), {});

export const mapContactToPreviewContact = (
  contact,
  { customFieldsCatalog = [], includePropertyFields = false } = {}
) => {
  const fields = {};

  Object.entries(CONTACT_TOKEN_TO_PROPERTY).forEach(([token, property]) => {
    fields[token] = contact?.[property];
  });

  if (includePropertyFields) {
    const property = contact?.properties?.[0] || {};
    Object.entries(PROPERTY_TOKEN_TO_PROPERTY).forEach(([token, key]) => {
      fields[token] = property[key];
    });
  }

  const customFieldValues = getCustomFieldValues(contact);
  customFieldsCatalog.forEach((field) => {
    if (field?.key && field?.value) {
      fields[field.key] = customFieldValues[field.value];
    }
  });

  return {
    id: contact.id,
    title: getContactTitle(contact),
    subtitle: getContactSubtitle(contact),
    fields,
  };
};

// Mirrors the Create Order contact search: only the first two words are sent.
export const normalizePreviewSearch = (search) => {
  const trimmed = (search || '').replace(/^(\S+\s+\S+)\s*(.*)/, '$1').trim();
  return trimmed || undefined;
};
